/* The Good Monk - store locator
   Leaflet + CARTO tiles (no API key). Store coordinates are baked into the
   server-rendered list; this script reads them from the DOM so the list stays
   the single source of truth. */
(function () {
  'use strict';

  var root = document.querySelector('[data-locator]');
  if (!root || typeof L === 'undefined') return;

  var mapEl    = root.querySelector('[data-map]');
  var listEl   = root.querySelector('[data-list]');
  var input    = root.querySelector('[data-search-input]');
  var form     = root.querySelector('[data-search-form]');
  var regionEl = root.querySelector('[data-region-filter]');
  var nearBtn  = root.querySelector('[data-near]');
  var countEl  = root.querySelector('[data-count]');
  var emptyEl  = root.querySelector('[data-empty]');
  var items    = Array.prototype.slice.call(root.querySelectorAll('[data-store]'));
  if (!mapEl || !items.length) return;

  var RED = '#da1a15';

  /* ---------- map ---------- */
  var map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true })
    .setView([parseFloat(root.dataset.centerLat) || -28.8,
              parseFloat(root.dataset.centerLng) || 25.5],
             parseInt(root.dataset.zoom, 10) || 5);

  // OpenStreetMap standard tiles: no API key, no billing, no sign-up.
  // (CARTO's basemaps now require a key.) The muted look is applied in CSS via a
  // desaturation filter on the tile pane rather than by paying for a styled basemap.
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19
  }).addTo(map);

  // Scroll wheel zoom only once the user has actually engaged with the map,
  // so the page still scrolls normally when you swipe past it.
  map.on('click focus', function () { map.scrollWheelZoom.enable(); });
  map.on('mouseout', function () { map.scrollWheelZoom.disable(); });

  var icon = L.divIcon({
    className: 'locator-pin',
    html: '<span class="locator-pin__dot"></span>',
    iconSize: [22, 22],
    iconAnchor: [11, 11],
    popupAnchor: [0, -11]
  });

  /* ---------- build markers from the rendered list ---------- */
  var group = L.featureGroup().addTo(map);

  items.forEach(function (li, i) {
    var lat = parseFloat(li.dataset.lat), lng = parseFloat(li.dataset.lng);
    if (isNaN(lat) || isNaN(lng)) { li._marker = null; return; }

    var name = (li.querySelector('[data-pick]') || {}).textContent || '';
    var addr = (li.querySelector('.locator__addr') || {}).textContent || '';
    var tel  = li.querySelector('.locator__tel');
    var dir  = li.querySelector('.locator__dir');

    var html = '<div class="locator-pop">' +
      '<strong class="locator-pop__name"></strong>' +
      '<span class="locator-pop__addr"></span>' +
      (tel ? '<a class="locator-pop__tel" href="' + tel.getAttribute('href') + '"></a>' : '') +
      (dir ? '<a class="locator-pop__dir" href="' + dir.getAttribute('href') + '" target="_blank" rel="noopener">Directions</a>' : '') +
      '</div>';
    var node = document.createElement('div');
    node.innerHTML = html;
    node.querySelector('.locator-pop__name').textContent = name;
    node.querySelector('.locator-pop__addr').textContent = addr;
    if (tel) node.querySelector('.locator-pop__tel').textContent = tel.textContent;

    var m = L.marker([lat, lng], { icon: icon, title: name }).bindPopup(node, { closeButton: true });
    m.on('click', function () { highlight(li, false); });
    li._marker = m;
    li._lat = lat; li._lng = lng;
    li._order = i;
    group.addLayer(m);
  });

  /* ---------- region filter options ---------- */
  var regions = [];
  items.forEach(function (li) {
    var r = li.dataset.region;
    if (r && regions.indexOf(r) === -1) regions.push(r);
  });
  regions.forEach(function (r) {
    var o = document.createElement('option');
    o.value = r; o.textContent = r;
    regionEl.appendChild(o);
  });

  /* ---------- helpers ---------- */
  function highlight(li, pan) {
    items.forEach(function (x) { x.classList.remove('is-active'); });
    li.classList.add('is-active');
    if (pan && li._marker) {
      map.flyTo([li._lat, li._lng], Math.max(map.getZoom(), 14), { duration: 0.6 });
    }
    if (li._marker) li._marker.openPopup();
    if (!pan) {
      // marker click: bring the matching row into view in the list
      var p = listEl.getBoundingClientRect(), r = li.getBoundingClientRect();
      if (r.top < p.top || r.bottom > p.bottom) {
        listEl.scrollTop += (r.top - p.top) - 12;
      }
    }
  }

  function visible() { return items.filter(function (li) { return !li.hidden; }); }

  function fit() {
    var shown = visible().filter(function (li) { return li._marker; });
    group.clearLayers();
    shown.forEach(function (li) { group.addLayer(li._marker); });
    if (shown.length === 1) {
      map.flyTo([shown[0]._lat, shown[0]._lng], 14, { duration: 0.6 });
    } else if (shown.length > 1) {
      map.flyToBounds(group.getBounds().pad(0.15), { duration: 0.6 });
    }
  }

  function apply() {
    var q = (input.value || '').trim().toLowerCase();
    var reg = regionEl.value;
    var n = 0;
    items.forEach(function (li) {
      var okQ = !q || (li.dataset.search || '').indexOf(q) > -1;
      var okR = !reg || li.dataset.region === reg;
      li.hidden = !(okQ && okR);
      if (!li.hidden) n++;
    });
    countEl.textContent = n + (n === 1 ? ' stockist' : ' stockists');
    emptyEl.hidden = n !== 0;
    fit();
  }

  /* ---------- events ---------- */
  items.forEach(function (li) {
    var btn = li.querySelector('[data-pick]');
    if (btn) btn.addEventListener('click', function () { highlight(li, true); });
  });

  form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });
  var t;
  input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(apply, 180); });
  regionEl.addEventListener('change', apply);

  /* ---------- near me ---------- */
  function km(a, b, c, d) {
    var R = 6371, p = Math.PI / 180;
    var dLat = (c - a) * p, dLng = (d - b) * p;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(a * p) * Math.cos(c * p) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
  }

  if (nearBtn) {
    nearBtn.addEventListener('click', function () {
      if (!navigator.geolocation) { nearBtn.textContent = 'Location unavailable'; return; }
      nearBtn.classList.add('is-busy');
      navigator.geolocation.getCurrentPosition(function (pos) {
        var la = pos.coords.latitude, ln = pos.coords.longitude;
        nearBtn.classList.remove('is-busy');
        nearBtn.classList.add('is-on');

        // reset filters so "nearest" means nearest overall
        input.value = ''; regionEl.value = '';
        items.forEach(function (li) {
          li.hidden = false;
          if (li._lat != null) {
            li._km = km(la, ln, li._lat, li._lng);
            var tag = li.querySelector('.locator__dist') || document.createElement('span');
            tag.className = 'locator__dist';
            tag.textContent = (li._km < 1 ? Math.round(li._km * 1000) + ' m' : li._km.toFixed(1) + ' km') + ' away';
            var reg = li.querySelector('.locator__region');
            if (reg && !li.querySelector('.locator__dist')) reg.appendChild(tag);
          } else { li._km = Infinity; }
        });
        items.slice().sort(function (a, b) { return (a._km || 0) - (b._km || 0); })
             .forEach(function (li) { listEl.appendChild(li); });

        countEl.textContent = items.length + ' stockists, nearest first';
        emptyEl.hidden = true;
        L.circleMarker([la, ln], {
          radius: 8, color: '#fff', weight: 3, fillColor: RED, fillOpacity: 1
        }).addTo(map).bindPopup('You are here');

        var near = items.filter(function (li) { return li._marker; }).slice(0, 3);
        if (near.length) {
          var b = L.latLngBounds(near.map(function (li) { return [li._lat, li._lng]; }));
          b.extend([la, ln]);
          map.flyToBounds(b.pad(0.2), { duration: 0.8 });
        }
        listEl.scrollTop = 0;
      }, function () {
        nearBtn.classList.remove('is-busy');
        nearBtn.textContent = 'Location blocked';
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
    });
  }

  /* ---------- go ---------- */
  apply();
  setTimeout(function () { map.invalidateSize(); fit(); }, 200);
})();
